import actions from './ru-RU/actions';
import admin from './ru-RU/admin';
import common from './ru-RU/common';
import error from './ru-RU/error';
import features from './ru-RU/features';
import form from './ru-RU/form';
import menu from './ru-RU/menu';
import messages from './ru-RU/messages';
import price from './ru-RU/price';
import scheduler from './ru-RU/scheduler';
import subscriptions from './ru-RU/subscriptions';
import table from './ru-RU/table';
import tenants from './ru-RU/tenants';

export default {
  ...actions,
  ...admin,
  ...common,
  ...error,
  ...form,
  ...menu,
  ...features,
  ...messages,
  ...price,
  ...table,
  ...tenants,
  ...subscriptions,
  ...scheduler,
};
